/** Types for First Chapter Journey admin reporting APIs (admin-backend 3001). */

export interface DateRangeMeta {
  range: string;
  from: string;
  to: string;
}

export interface JourneySummaryData {
  total_journeys: number;
  by_state: Record<string, number>;
  conversion_rate: number;
  offer_redemption_rate: number;
  offer_window_count?: number;
  range: DateRangeMeta;
  awaiting_migration?: boolean;
}

export interface SendStepRow {
  key: string;
  channel: 'push' | 'in_app' | string;
  sent: number;
  opened: number;
  open_rate: number;
  resulting_state_advances: number | null;
}

export interface SendsData {
  steps: SendStepRow[];
  totals: { push_sent: number; in_app_shown: number; total_opened: number };
  range: DateRangeMeta;
  awaiting_migration?: boolean;
}

export interface OfferBucket {
  shown?: number;
  redeemed?: number;
  issued?: number;
  redemption_rate: number;
  revenue_attributed?: number;
}

export interface OfferPerformanceData {
  voice50: OfferBucket;
  cyndy50: OfferBucket;
  full_price_conversions_at_pn04: number;
  range: DateRangeMeta;
}

export interface TimelinePoint {
  date: string;
  push_sent: number;
  in_app_shown: number;
  opened: number;
  conversions: number;
}

export interface TimelineData {
  series: TimelinePoint[];
  range: DateRangeMeta;
  awaiting_migration?: boolean;
}

export const JOURNEY_STATE_LABELS: Record<string, string> = {
  installed: 'Installed',
  chapter_started: 'Chapter started',
  chapter_completed: 'Chapter completed',
  shared: 'Shared',
  offer_window: 'Offer window',
  converted: 'Converted',
  exited: 'Exited',
};

/** Short hints for Send Performance rows — title + when it fires. */
export const NOTIFICATION_KEY_HINTS: Record<string, string> = {
  'PN-01': '“Your first Chapter is waiting” · ~2h after install · create',
  'PN-01B': '“If you can tell a story…” · ~24h after install · create',
  'PN-02': '“Your Chapter is safe and waiting” · ~4h after last edit · resume',
  'PN-02B': '“Your story deserves its ending” · ~24h after last edit · resume',
  'PN-03': '“Congratulations — first Chapter complete” · ~1h after complete · view',
  'PN-03B': '“Someone you love would treasure this” · ~24h after complete · share',
  'PN-04': '“Your Life Book has room…” · ~24h after complete · subscribe',
  'PN-05': '“A gift for our newest storyteller” · offer window · VOICE50',
  'PN-05B': '“Your invitation is still open” · ~96h after complete · VOICE50',
  'IA-01': 'In-app: start first Chapter (mirrors PN-01)',
  'IA-02': 'In-app: resume Chapter (mirrors PN-02)',
  'IA-03': 'In-app: view completed Chapter (mirrors PN-03)',
  'IA-04': 'In-app: see Membership options (mirrors PN-04)',
  'IA-05': 'In-app: 50% off Premium / VOICE50 (mirrors PN-05)',
};
